// extracted by mini-css-extract-plugin
export var option = "_41-1";
export var optionActive = "_41-2";
export var pill = "_41-0";